import React from "react";
import Items from "./Items";
import Title from "./Title";

const PopularSale = ({ data, popular_Sales, setCartItems, cartItems }) => {
  const { title, items } = data;
  return (
    <div className="nike-container">
      <Title title={title} />
      <div
        className={`grid items-center justify-items-center ${
          popular_Sales ? "grid-cols-3 lg:grid-cols-1 md:grid-cols-2 sm:grid-cols-1 xsm:grid-cols-1 " : "grid-cols-4 lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1"
        }  gap-4 lg:gap-5 mt-7`}
      >
        {items?.map((item, index) => (
          <Items key={index} item={item} popular_Sales={popular_Sales} setCartItems={setCartItems} cartItems={cartItems} />
        ))}
      </div>
    </div>
  );
};

export default PopularSale;
